module.exports = ".horizontal-language {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.horizontal-language li {\n  padding: 0px 5px; }\n\n.horizontal-language li a {\n  color: #03A7E0;\n  opacity: 1; }\n\n.horizontal-language li.active a {\n  color: #334E69;\n  opacity: 0.25; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/translation/components/language-horizontal/language-horizontal.component.scss
// module id = ./src/app/translation/components/language-horizontal/language-horizontal.component.scss
// module chunks = main